<template>
	<v-container fluid>
		<v-row no-gutters style="position: relative">
			<p class="title primary--text font-weight-bold" v-translate>Clinic History</p>
			<v-spacer></v-spacer>
			<v-btn
				v-if="false"
				small
				color="primary"
				dark
				height="38px"
				style="right: 360px"
				absolute
				@click="downloadPDF"
				:loading="loadingPDF"
			>
				<v-icon small class="mr-1">mdi-download</v-icon>
				PDF
			</v-btn>
			<v-btn
				small
				:color="documents.length > 0 ? 'green' : 'primary'"
				dark
				height="38px"
				style="right: 200px"
				absolute
				@click="showDocuments = true"
			>
				<v-icon small class="mr-1">mdi-file-document</v-icon>
				<translate>Documents</translate>
				<v-dialog v-model="showDocuments" width="50%" scrollable>
					<v-card>
						<v-card-title class="title primary--text mb-2 secondary">
							<translate>Documents</translate>
						</v-card-title>
						<v-card-text>
							<DocumentsList :documents="documents" />
						</v-card-text>
						<v-divider></v-divider>
							<v-card-actions>
								<v-btn color="primary darken-1" text @click="showDocuments = false">
									<translate>Close</translate>
								</v-btn>
							</v-card-actions>
					</v-card>
				</v-dialog>
			</v-btn>
			<v-select
				color="primary"
				background-color="primary"
				class="text-caption font-weight-medium bloodSelect"
				style="text-transform: uppercase; width: 180px; position: absolute; right: 0"
				dense
				solo
				:items="bloodTypes"
				v-model="patient.blood_type"
				hide-details
				@change="editBloodType"
				:disabled="!$store.getters.hasAnyModule"
			>
				<template v-slot:append>
					<v-icon color="white" small class="mr-1">mdi-water</v-icon>
				</template>
				<template v-slot:selection="{ item }">
					<v-icon color="white" small class="mr-1">mdi-water</v-icon>
					<span class="white--text" v-translate>Blood Type</span>
					<span class="white--text mx-1">:</span>
					<span class="white--text">{{item.text}}</span>
				</template>
			</v-select>
		</v-row>
		<template v-if="appointments.length == 0">
			<p class="font-weight-thin ml-2" v-translate>No history.</p>
			<v-btn
				v-if="patient.id && $store.getters.canCreateAppointment"
				small
				color="primary"
				:to="{name: 'patient-new-appointment', params: {pid: patient.id, patient: patient}}"
				:disabled="!$store.getters.hasAnyModule"
			>
				<v-icon small class="mr-1">add</v-icon>
				<translate>New Appointment</translate>
			</v-btn>
		</template>
		<template v-else>
			<v-row no-gutters>
				<v-col cols="12">
					<v-row no-gutters>
					<v-btn
						color="primary"
						icon
						@click="showSearchICDs = !showSearchICDs"
					>
						<v-icon v-if="showSearchICDs">mdi-chevron-up</v-icon>
						<v-icon v-else>mdi-chevron-down</v-icon>
					</v-btn>
					<v-spacer>
					</v-spacer>
					<v-btn
						v-if="patient.id && $store.getters.canCreateAppointment"
						small
						color="primary"
						:to="{name: 'patient-new-appointment', params: {pid: patient.id, patient: patient}}"
						:disabled="!$store.getters.hasAnyModule"
						class="mt-2"
					>
						<v-icon small class="mr-1">add</v-icon>
						<translate>New Appointment</translate>
					</v-btn>
					</v-row>
				</v-col>
				<v-col cols="12" v-if="showSearchICDs">
					<v-row no-gutters v-if="professionals.length > 0">
						<v-btn-toggle v-model="professionalFilter" mandatory color="primary">
							<v-btn value="all" small class="text-overline">
								<v-icon small color="primary" class="mr-2">people</v-icon>
								<translate>All</translate>
							</v-btn>
							<v-btn :value="$store.getters.userId" small class="text-overline">
								<v-icon small :color="$store.getters.userColor" class="mr-2">person</v-icon>
								<translate>Own</translate>
							</v-btn>
						</v-btn-toggle>
					</v-row>
					<v-row no-gutters class="my-2">
						<v-btn-toggle v-model="infoFilter" @change="changeInfoFilter" mandatory color="primary" :style="$store.getters.tourMode ? {'position': 'relative', 'z-index': 400, 'background': '#FFFFFF'} : ''">
							<v-btn value="anamnesis" small class="text-overline" :disabled="loading">
								<v-icon small color="primary" class="mr-2">mdi-clipboard-alert</v-icon>
								<span v-translate>Anamnesis</span>
							</v-btn>
							<v-btn value="tests" small class="text-overline" :disabled="loading">
								<v-icon small color="primary" class="mr-2">mdi-chart-box</v-icon>
								<translate>Tests</translate>
							</v-btn>
							<v-btn value="diagnosis" small class="text-overline" :disabled="loading">
								<v-icon small color="primary" class="mr-2">mdi-clipboard-check</v-icon>
								<translate>Diagnosis</translate>
							</v-btn>
							<v-btn value="treatments" small class="text-overline" :disabled="loading">
								<v-icon small color="primary" class="mr-2">mdi-clipboard-text</v-icon>
								<translate>Treatments</translate>
							</v-btn>
						</v-btn-toggle>
					</v-row>
				</v-col>
				<v-col cols="12" class="my-2" v-if="showSearchICDs">
					<v-combobox
						v-model="searchedICDs"
						:items="availableICDs"
						chips
						clearable
						:label="$gettext('Filter by ICD')"
						multiple
						solo
						item-text="title"
						item-value="code"
						hide-details
					>
						<template v-slot:prepend>
							<v-menu
								:close-on-content-click="false"
								bottom
							>
								<template v-slot:activator="{ on, attrs }">
									<v-icon v-bind="attrs" v-on="on" class="mt-3">mdi-filter-variant</v-icon>
								</template>
								<v-card>
								<v-list-item-group
									v-model="selectedICDCategories"
									multiple
									value="id"
								>
									<v-list-item v-for="icdCategory in icdCategories" :key="icdCategory.id" :value="icdCategory.id">
										<template v-slot:default="{ active, }">
											<v-list-item-action>
												<v-checkbox
													:input-value="active"
													color="primary"
												></v-checkbox>
											</v-list-item-action>

											<v-list-item-content>
												<v-list-item-title>{{icdCategory.name}}</v-list-item-title>
											</v-list-item-content>
										</template>
									</v-list-item>
								</v-list-item-group>
								</v-card>
							</v-menu>
						</template>
						<template slot="item" slot-scope="data">
							{{ data.item.code }} - {{ data.item.title }}
						</template>
						<template v-slot:selection="{ attrs, item, select, selected }">
							<v-chip
								small
								v-bind="attrs"
								:input-value="selected"
								close
								@click="select"
								@click:close="removeICDSearch(item)"
							>
								<span>{{item.title}}</span>&nbsp;
								<span class="ml-1">({{item.code}})</span>
							</v-chip>
						</template>
					</v-combobox>
				</v-col>
			</v-row>
			<VueHtml2pdf
				v-if="false"
				:show-layout="false"
				:float-layout="true"
				:enable-download="true"
				:paginate-elements-by-height="10000000"
				filename="test"
				:pdf-quality="2"
				pdf-format="a4"
				ref="html2Pdf"
				:preview-modal="true"
				:html-to-pdf-options="{html2canvas: {useCORS: true}, pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }}"
				@hasDownloaded="loadingPDF = false"
			>
				<section slot="pdf-content">
					<v-app>
						<v-container fluid>
							<v-list flat class="secondary px-2">
								<ClinicHistoryItem
									v-for="appointment in filteredAppointments"
									:patient="patient"
									:pdfMode="true"
									:appointment="appointment"
									:patientAppointment="{ id: -1 }"
									:key="appointment.id"
									:documents="documents"
									@go-to-appointment="goToAppointment"
								/>
							</v-list>
						</v-container>
					</v-app>
				</section>
			</VueHtml2pdf>
			<v-list flat>
				<ClinicHistoryItem
					v-for="appointment in filteredAppointments"
					:patient="patient"
					:appointment="appointment"
					:patientAppointment="patientAppointment"
					:key="appointment.id"
					:documents="documents"
					:ref="'item' + appointment.id"
					@go-to-appointment="goToAppointment"
				/>
			</v-list>
		</template>
	</v-container>
</template>

<script>
import ClinicHistoryItem from "@/components/patient/ClinicHistoryItem.vue";
import DocumentsList from "@/components/appointment/anamnesis/DocumentsList.vue";
import scrollTo from "vue-scrollto";
import axios from "axios";
import { mapGetters } from 'vuex';
import VueHtml2pdf from 'vue-html2pdf';

export default {
	name: "ClinicHistory",
	props: [
		"patientAppointment",
		"appointments",
		"documents",
		"patient",
		"inAppointment"
	],
	directives: {
		scrollTo
	},
	components: {
		ClinicHistoryItem,
		DocumentsList,
		VueHtml2pdf
	},
	data: () => ({
		editAppointment: false,
		professionalFilter: "all",
		infoFilter: "anamnesis",
		bloodTypes: [
			{ text: "AB+", value: "ab+" },
			{ text: "AB-", value: "ab-" },
			{ text: "B+", value: "b+" },
			{ text: "B-", value: "b-" },
			{ text: "A+", value: "a+" },
			{ text: "A-", value: "a-" },
			{ text: "O+", value: "o+" },
			{ text: "O-", value: "o-" },
			{ text: "N/A", value: null }
		],
		showSearchICDs: false,
		searchedICDs: [],
		selectedICDCategories: ['chief_complaint', 'gen_diagnose'],
		autoselectMenu: false,
		loading: false,
		showDocuments: false,
		paperSize: "a4",
		loadingPDF: false
	}),
	methods: {
		containsProfessional(obj, list) {
			var i;
			for (i = 0; i < list.length; i++) {
				if (list[i].id == obj.id) {
					return true;
				}
			}
			return false;
		},
		changeInfoFilter() {
			if(this.infoFilter == 'tests' || this.infoFilter == 'treatments') this.getInfo();
			else this.setInfoFilter();
		},
		getInfo(filter = null) {
			this.loading = true;
			let filterText =  filter ? filter : this.infoFilter;
			return new Promise((resolve, reject) => {
				axios
				.get("/patient/" + this.patient.id + "/history/" + filterText)
				.then(response => {
					console.log(response.data);
					for(let i = 0; i < response.data.appointments.length; i++) {
						if(this.infoFilter == 'tests' || filter == 'tests-and-treatments') {
							this.appointments[i].tests = response.data.appointments[i].tests;
							this.appointments[i].custom_tests = response.data.appointments[i].custom_tests;
						} 
						if(this.infoFilter == 'treatments' || filter == 'tests-and-treatments') {
							this.appointments[i].ashi_points = response.data.appointments[i].ashi_points;
							this.appointments[i].acu_points = response.data.appointments[i].acu_points;
							this.appointments[i].supplements = response.data.appointments[i].supplements;
							this.appointments[i].formulas = response.data.appointments[i].formulas;
							this.appointments[i].other_treatments = response.data.appointments[i].other_treatments;
							this.appointments[i].custom_treatments = response.data.appointments[i].custom_treatments;
						}
					}
					this.loading = false;
					this.setInfoFilter();
					resolve();
				})
				.catch(error => {
					console.log(error);
					this.loading = false;
					reject();
				});
			});
		},
		setInfoFilter() {
			for(let i = 0; i < this.filteredAppointments.length; i++) {
				let refName = 'item' + this.filteredAppointments[i].id;
				this.$refs[refName][0].changeFilter(this.infoFilter);
			}
		},
		goToAppointment(appointmentId) {
			const patientId = this.$route.params.pid;
			this.$router.push({
				name: "appointment",
				params: { pid: patientId, aid: appointmentId, fromPatient: true, historyAppointments: this.appointments, historyDocuments: this.documents, historyPatient: this.patient }
			});
		},
		scrollToCurrentAppointment() {
			scrollTo.scrollTo(this.$refs['item'+this.patientAppointment.id][0].$el, 500, {offset: -300});
		},
		removeICDSearch(item) {
			this.searchedICDs.splice(this.searchedICDs.indexOf(item), 1);
		},
		hasICD(appointment) {
			for(let i = 0; i < appointment.symptoms.length; i++){
				for(let h = 0; h < this.searchedICDs.length; h++) {
					if(this.searchedICDs[h].code == appointment.symptoms[i].code && this.selectedICDCategories.includes(appointment.symptoms[i].type)) return true;
				}
			}
			return false;
		},
		hasICDs(appointment) {
			for(let h = 0; h < this.searchedICDs.length; h++) {
				if(this.selectedICDCategories.length > 0) {
					for(let c = 0; c < this.selectedICDCategories.length; c++) {
						let existCategory = false;
						for(let i = 0; i < appointment.symptoms.length; i++){
							if(this.searchedICDs[h].code == appointment.symptoms[i].code && this.selectedICDCategories[c] == appointment.symptoms[i].type) existCategory = true;
						}
						if(!existCategory) return false;
					}
				}
				else {
					let exist = false;
					for(let i = 0; i < appointment.symptoms.length; i++){
						if(this.searchedICDs[h].code == appointment.symptoms[i].code) exist = true;
					}
					if(!exist) return false;
				}
			}
			return true;
		},
		filterByICDs(appointments) {
			if(this.searchedICDs.length == 0) return appointments;
			var filteredApps = [];
			for(let i = 0; i < appointments.length; i++) {
				if(this.hasICDs(appointments[i])) filteredApps.push(appointments[i]);
			}
			return filteredApps;
		},
		downloadPDF() {
			this.loadingPDF = true;
			this.getInfo('tests-and-treatments').then(() => {
				this.$refs.html2Pdf.generatePdf();
			});
		},
		editBloodType() {
			const formData = new FormData();
			formData.append("blood_type", this.patient.blood_type);
			formData.append("clinic_submit", true);
			axios
				.post("/patient/" + this.patient.id, formData)
				.then(response => {
					console.log(response.data);
				})
				.catch(error => console.log(error));
		}
	},
	computed: {
		professionals() {
			var professionals = [];
			this.appointments.forEach(a => {
				if (!this.containsProfessional(a.user, professionals))
					professionals.push(a.user);
			});
			return professionals;
		},
		filteredAppointments() {
			if (this.professionalFilter == "all") return this.filterByICDs(this.appointments);
			else {
				var filteredApps = [];
				this.appointments.forEach(a => {
					if (a.user_id == this.professionalFilter) filteredApps.push(a);
				});
				return this.filterByICDs(filteredApps);
			}
		},
		icdCategories() {
			return [
				{id: 'chief_complaint', name: this.$gettext('Chief Complaint')},
				{id: 'history_illness', name: this.$gettext('History of the present illness')},
				{id: 'past_medical', name: this.$gettext('Past medical history')},
				{id: 'family_history', name: this.$gettext('Family history')},
				{id: 'life_habits', name: this.$gettext('Life habits')},
				{id: 'review_systems', name: this.$gettext('Review of Systems')},
				{id: 'comparative_assessment', name: this.$gettext('Comparative assessment')},
				{id: 'gen_diagnose', name: this.$gettext('Biomedical Diagnosis')},
				{id: 'mtc_diagnose', name: this.$gettext('TCM Diagnosis')}
			]
		},
		availableICDs() {
			let availableList = [];
			for(let i = 0; i < this.appointments.length; i++){
				for(let h = 0; h < this.appointments[i].symptoms.length; h++) {
					availableList.push({code: this.appointments[i].symptoms[h].code, title: this.appointments[i].symptoms[h].title})
				}
			}
			return availableList;
		},
		...mapGetters({
			tourStep: 'tourStepEvent'
		})
	},
	created() {
		if(this.$store.getters.tourMode) this.showSearchICDs = true;
	},
	watch: {
		tourStep(value) {
			if(value == 'tour-select-clinic-history-tests') {
				this.infoFilter = 'tests';
				this.changeInfoFilter();
			}
			else if(value == 'tour-select-clinic-history-diagnosis') {
				this.infoFilter = 'diagnosis';
				this.changeInfoFilter();
			}
			else if(value == 'tour-select-clinic-history-treatments') {
				this.infoFilter = 'treatments';
				this.changeInfoFilter();
			}
		}
	}
};
</script>

<style scoped>
>>> .bloodSelect .v-select__selections input {
	display: none;
}
>>> .bloodSelect .v-input__append-inner {
	display: none;
}

>>> .v-text-field.v-text-field--solo .v-input__prepend-outer, .v-text-field.v-text-field--solo .v-input__append-outer {
	margin-top: 0px;
}
</style>

<style scoped>
.currentAppointment {
	border: 3px solid primary;
}
</style>